<template>
  <section class="simple-slider" :class="sliderClasses">
    <tiny-slider v-bind="sliderConfig" ref="slider">
      <slot></slot>
    </tiny-slider>
    <div class="simple-slider__controls" v-if="hasControls">
      <button class="button is-small is-inverted" @click="goBack">
        <span class="icon is-large" v-icon:arrow_left></span>
      </button>
      <button class="button is-small is-inverted" @click="goForward">
        <span class="icon is-large" v-icon:arrow_right></span>
      </button>
    </div>
  </section>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: "SimpleSlider",
        data() {
            return {
                baseConfig: {
                    autoplay: true,
                    autoplayButtonOutput: false,
                    autoplayHoverPause: true,
                    controls: false,
                    nav: false,
                    autoplayTimeout: 7000
                }
            }
        },
        computed: {
            sliderClasses() {
                return {
                    'is-vertical': this.sliderConfig.axis === 'vertical',
                    'has-controls': this.hasControls,
                    'has-nav': this.hasNav
                }
            },
            hasNav() {
                return this.sliderConfig.nav !== false ||
                    (this.sliderConfig.responsive && Object.values(this.sliderConfig.responsive).some(x => x.nav !== false));
            },
            hasControls() {
                return this.$attrs.controls !== false;
            },
            sliderConfig() {
                return {
                    ...this.baseConfig,
                    ...this.$attrs,
                    controls: false
                }
            }
        },
        methods: {
            goBack() {
                this.$refs.slider.goTo('prev');
            },
            goForward() {
                this.$refs.slider.goTo('next');
            }
        }
    }
</script>

